module.exports = __webpack_public_path__ + "img/project16_4.jpg.8424211e.webp";